import { suppliesInventoryConfigIdFormat } from "@redotech/redo-ids/ids";
import { SuppliesReorderStatusSchema } from "@redotech/redo-model/supplies";
import * as z from "zod";

export const updateSuppliesInventoryConfig = {
  name: "updateSuppliesInventoryConfig" as const,
  input: z.object({
    id: suppliesInventoryConfigIdFormat.schema,
    reorderStatus: SuppliesReorderStatusSchema.optional(),
    inventoryReorderThreshold: z.number().int().min(0).optional(),
    suppliesReorderQuantity: z.number().int().min(1).optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
